import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';
import OpenerImage from '../common/opener_image';
import FeaturedCardElements from './featured_card_elements';
import { sendAnalyticsEvent, sendDataLayerEvent } from '../../utils/analytics';

export default class FeaturedCard extends Component {
  handleClick = () => {
    sendAnalyticsEvent(
      'Featured Stories',
      'Click',
      `Featured Story ${this.props.indexWithinRow}`
    );

    sendDataLayerEvent(
      'Click',
      {
        module_name: 'Featured stories',
        cta_text: this.props.truncated_title_80,
        destination_url: this.props.url,
        position: this.props.indexWithinRow - 1,
        linkUID: this.props.id,
        linkType: 'article',
        linkTitle: this.props.truncated_title_80,
        itemName: this.props.truncated_title_80,
        linkHeadline: this.props.truncated_title_80
      }
    );
  }


  openerRowType = () => this.props.firstInRow
    ? 'first-' + this.props.rowType
    : this.props.rowType;

  render() {
    return (
      <div className="card featured-story" onClick={this.handleClick}>
        <Link to={this.props.url}>
          <OpenerImage
            opener_images={this.props.opener_images}
            rowType={this.openerRowType()}
            isVideoCard={this.props.isVideoCard}
          />
          <FeaturedCardElements
            contributors={this.props.contributors}
            id={this.props.id}
            isVideoCard={this.props.isVideoCard}
            label={this.props.label}
            meta={this.props.meta}
            truncated_title_80={this.props.truncated_title_80}
            published={this.props.published}
            page_id={this.props.page_id}
            blog_series={this.props.blog_series}
            isHomepageRefresh={this.props.isHomepageRefresh}
          />
        </Link>
      </div>
    );
  }
}

FeaturedCard.propTypes = {
  firstInRow: PropTypes.bool.isRequired,
  indexWithinRow: PropTypes.number.isRequired,
  rowType: PropTypes.string.isRequired,
  contributors: PropTypes.arrayOf(
    PropTypes.object.isRequired
  ).isRequired,
  id: PropTypes.number.isRequired,
  isVideoCard: PropTypes.bool,
  label: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    sold_content_type: PropTypes.string
  }),
  opener_images: PropTypes.arrayOf(
    PropTypes.object.isRequired
  ).isRequired,
  truncated_title_80: PropTypes.string.isRequired,
  published: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  page_id: PropTypes.number.isRequired,
  blog_series: PropTypes.object.isRequired,
  isHomepageRefresh: PropTypes.bool.isRequired
};

FeaturedCard.defaultProps = {
  contributors: [],
  label: '',
  meta: {},
  opener_images: [],
  truncated_title_80: '',
  published: 0,
  url: ''
};
